import { render } from "./CancelarMatricula.vue?vue&type=template&id=7daa724a&scoped=true"
import script from "./CancelarMatricula.vue?vue&type=script&lang=js"
export * from "./CancelarMatricula.vue?vue&type=script&lang=js"

import "./CancelarMatricula.vue?vue&type=style&index=0&id=7daa724a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daa724a"]])

export default __exports__